(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LT-sticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticker-animated')) {
    class StickerAnimated extends HTMLElement {
      constructor() {
        super()
        this.animationSpeed = parseFloat(this.dataset.animationSpeed)

        this.init()

        document.addEventListener('readystatechange', function() {
          if(document.readyState == 'interactive') {
          }
        })
        document.addEventListener("shopify:section:load", (event) => {
          this.init()
        });
      }
      init() {
        this.selecter = ".stckrimg"
        this.stckrimgs = this.querySelectorAll(this.selecter);
        this.scroll();
      }
      scroll() {
        Array.from(this.stckrimgs).forEach(stckrimg => {
          window.addEventListener("scroll", () => {
            const section = stckrimg.closest(`.shopify-section`)
            const LT__section = stckrimg.closest(`.luna-templates__animated-sticker`)
            const sticker = this.querySelector('.luna-templates-animated-sticker');
            const {bottom, top} = sticker.getBoundingClientRect();

            if (top > 0 && (bottom - window.innerHeight) < 0) {
              if (LT__section.dataset.animation == "spin-scroll") {
                stckrimg.style.rotate = (bottom * this.animationSpeed) + "deg";
                stckrimg.style.top = 0 + "px";
              }

              if (LT__section.dataset.animation == "float-scroll") {
                stckrimg.style.rotate = 0 + "deg";
                // stckrimg.style.top = ((bottom + (window.innerHeight / 2)) * this.animationSpeed) + "px";
                stckrimg.style.top = (((sticker.offsetTop + this.offsetTop) - (window.scrollY + (window.innerHeight / 2))) * this.animationSpeed) + "px";
              }
            }
          }, {
            passive: true,
            capture: false,
          })
        })
      }
    }
    customElements.define('sticker-animated', StickerAnimated)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ia-section-testimonial-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Use standard var instead of const/let for older browser compatibility
    var testimonialsScript = {
      init: function () {
        // Wait for DOM to be fully loaded
        document.addEventListener('DOMContentLoaded', this.onDOMLoaded.bind(this));
      },

      onDOMLoaded: function () {
        // Find all testimonial sliders by data attribute
        var sliders = document.querySelectorAll('[data-section-type="testimonial-slider"]');

        // Initialize each slider
        for (var i = 0; i < sliders.length; i++) {
          this.initSlider(sliders[i]);
        }
      },

      initSlider: function (container) {
        // Find elements by attribute selectors instead of class names with section ID
        var sliderWrapper = container.querySelector('[role="list"]');
        var prevButton = container.querySelector('[aria-label="Previous slide"]');
        var nextButton = container.querySelector('[aria-label="Next slide"]');

        // Check if required elements exist
        if (!sliderWrapper || !prevButton || !nextButton) {
          console.error('Required slider elements not found');
          return;
        }

        var slides = sliderWrapper.children;
        if (!slides.length) {
          console.error('No slides found');
          return;
        }

        console.log('Initializing slider with ' + slides.length + ' slides');

        // Set up slider state
        var state = {
          currentPosition: 0,
          totalSlides: slides.length,
        };

        // Set up handlers
        prevButton.addEventListener('click', function (e) {
          e.preventDefault();
          moveSlider(state.currentPosition - 1);
        });

        nextButton.addEventListener('click', function (e) {
          e.preventDefault();
          moveSlider(state.currentPosition + 1);
        });

        // Handle touch events for mobile
        var touchStartX = 0;
        sliderWrapper.addEventListener(
          'touchstart',
          function (e) {
            touchStartX = e.touches[0].clientX;
          },
          { passive: true }
        );

        sliderWrapper.addEventListener(
          'touchend',
          function (e) {
            var touchEndX = e.changedTouches[0].clientX;
            var diff = touchEndX - touchStartX;

            if (diff > 50) {
              moveSlider(state.currentPosition - 1);
            } else if (diff < -50) {
              moveSlider(state.currentPosition + 1);
            }
          },
          { passive: true }
        );

        // Handle window resizing
        window.addEventListener('resize', function () {
          moveSlider(state.currentPosition);
        });

        // Move the slider to a specific position
        function moveSlider(position) {
          // Get number of visible slides based on viewport
          var visibleSlides = getVisibleSlides();
          var maxPosition = Math.max(0, state.totalSlides - visibleSlides);

          // Ensure position is within bounds
          position = Math.max(0, Math.min(position, maxPosition));
          state.currentPosition = position;

          // Calculate dimensions
          var slideWidth = slides[0].offsetWidth;
          var slideMargin = parseInt(window.getComputedStyle(slides[0]).marginRight, 10) || 24;
          var offset = position * (slideWidth + slideMargin);

          // Apply the transform
          sliderWrapper.style.transform = 'translateX(-' + offset + 'px)';

          // Update button states
          prevButton.disabled = position === 0;
          nextButton.disabled = position >= maxPosition;
          prevButton.classList.toggle('disabled', position === 0);
          nextButton.classList.toggle('disabled', position >= maxPosition);
        }

        // Calculate visible slides based on viewport width
        function getVisibleSlides() {
          var viewportWidth = window.innerWidth;
          if (viewportWidth < 640) return 1;
          if (viewportWidth < 1024) return 2;
          return 3;
        }

        // Initialize the slider position
        moveSlider(0);
      },
    };

    // Initialize the script
    testimonialsScript.init();
  })();

  // Replace the font application script with a simplified version
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      // We've removed all font styling from this script
      console.log('Testimonial section initialized');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
